/* ============================================================
   HydroMax — CURRENT
   Two motion moves only: Tick and Bubble. Rise (scroll fade-in-up) and
   Waterline (the blue sweep over the hero image) were removed page-wide.
   ============================================================ */
(() => {
'use strict';
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
const fmt = new Intl.NumberFormat('en-IN');

/* ---------- Tick ---------- */
function tick(el, target, dur = 1400) {
  if (reduced) { el.textContent = fmt.format(target); return; }
  const from = parseInt(String(el.textContent).replace(/[^\d-]/g, ''), 10) || 0;
  const t0 = performance.now();
  const step = (t) => {
    const p = Math.min((t - t0) / dur, 1);
    const e = 1 - Math.pow(1 - p, 4);
    el.textContent = fmt.format(Math.round(from + (target - from) * e));
    if (p < 1) requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
}
const cio = new IntersectionObserver((es) => {
  es.forEach(e => { if (e.isIntersecting) { tick(e.target, +e.target.dataset.count); cio.unobserve(e.target); } });
}, { threshold: 0.6 });
document.querySelectorAll('[data-count]').forEach(el => cio.observe(el));

/* ---------- meters ---------- */
const mio = new IntersectionObserver((es) => {
  es.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.querySelector('i').style.width = e.target.dataset.meter + '%';
    mio.unobserve(e.target);
  });
}, { threshold: 0.4 });
document.querySelectorAll('[data-meter]').forEach(el => mio.observe(el));

/* ---------- Bubble ---------- */
if (reduced) {
  document.querySelectorAll('.bubbles').forEach(b => b.remove());
} else {
  document.querySelectorAll('[data-bubbles]').forEach(box => {
    const n = +box.dataset.bubbles;
    const frag = document.createDocumentFragment();
    for (let i = 0; i < n; i++) {
      const b = document.createElement('i');
      const size = 4 + Math.random() * 16;
      b.style.width = b.style.height = size + 'px';
      b.style.left = (Math.random() * 100) + '%';
      b.style.animationDuration = (12 + Math.random() * 10) + 's';
      b.style.animationDelay = (-Math.random() * 22) + 's';
      b.style.setProperty('--dx', (Math.random() * 60 - 30) + 'px');
      frag.appendChild(b);
    }
    box.appendChild(frag);
  });
}

/* ---------- marquee: clone the track for a seamless loop ----------
   The logo strip is ~49 KB of inline SVG. Shipping it twice in the HTML to make
   the 50%-translate loop work would double that for no benefit, so the markup
   carries one copy and the duplicate is made here. */
document.querySelectorAll('[data-marquee]').forEach(track => {
  track.insertAdjacentHTML('beforeend', track.innerHTML);
  track.setAttribute('aria-hidden', 'true');
});

/* ---------- buy block: quantity × care plan → live total ---------- */
(() => {
  const UNIT = 12999, MAX_QTY = 9;
  const box    = document.querySelector('[data-qty]');
  const out    = document.querySelector('[data-qty-value]');
  const totals = document.querySelectorAll('[data-total]');
  /* The prepaid line under the buy button. Optional on purpose — the page is
     still whole without it, so a copy edit that drops it must not take the
     quantity stepper down with it. */
  const prepaid = document.querySelectorAll('[data-prepaid]');
  const PREPAID_OFF = 0.05;
  if (!box || !out || !totals.length) return;

  const inr = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });
  let qty = 1;

  function planPrice() {
    const sel = document.querySelector('input[name="careplan"]:checked');
    return sel ? +sel.value : 0;
  }
  function render() {
    out.textContent = qty;
    // The plan is charged ONCE per order, not per bottle: Protega's minted
    // plan products are quantity-capped at 1 (measured 2026-08-16 — a fresh
    // mint refuses quantity 2 with a 422 on both stores' plans), so a
    // (unit + plan) x qty promise could never ring up at qty 2+. The button
    // promises exactly what the register can charge.
    const total = UNIT * qty + planPrice();
    totals.forEach(t => { t.textContent = inr.format(total); });
    /* The prepaid price follows the same total, discount included, because the
       checkout's offer is an order-level 5% — it does not stop at the bottle.
       Rounded to the rupee (the totals carry no paise either), and rounded
       DOWN so the line can only ever understate what the customer saves. */
    prepaid.forEach(p => { p.textContent = inr.format(Math.floor(total * (1 - PREPAID_OFF))); });
    box.querySelector('[data-step="-1"]').disabled = qty <= 1;
    box.querySelector('[data-step="1"]').disabled  = qty >= MAX_QTY;
  }
  box.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-step]'); if (!btn) return;
    qty = Math.min(MAX_QTY, Math.max(1, qty + (+btn.dataset.step)));
    render();
  });
  document.querySelectorAll('input[name="careplan"]').forEach(r => r.addEventListener('change', render));
  render();
})();

/* ---------- PPB comparison bars (session 1) ---------- */
const bio = new IntersectionObserver((es) => {
  es.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.style.width = e.target.dataset.bar + '%';
    bio.unobserve(e.target);
  });
}, { threshold: 0.5 });
document.querySelectorAll('[data-bar]').forEach(el => bio.observe(el));

/* ---------- safety net ----------
   IntersectionObserver does not fire while the document is hidden (background
   tab, occluded pane). Without this, such a load leaves the page blank until
   the user scrolls. */
function sweepVisible() {
  const vh = innerHeight;
  document.querySelectorAll('[data-count]').forEach(el => {
    const r = el.getBoundingClientRect();
    if (el.textContent === '0' && r.top < vh && r.bottom > 0) { tick(el, +el.dataset.count); cio.unobserve(el); }
  });
  document.querySelectorAll('[data-meter]').forEach(el => {
    const r = el.getBoundingClientRect();
    if (r.top < vh && r.bottom > 0) el.querySelector('i').style.width = el.dataset.meter + '%';
  });
  document.querySelectorAll('[data-bar]').forEach(el => {
    const r = el.getBoundingClientRect();
    if (r.top < vh && r.bottom > 0) el.style.width = el.dataset.bar + '%';
  });
}
addEventListener('load', () => setTimeout(sweepVisible, 1200));

/* ---------- progress + active nav ---------- */
const bar = document.getElementById('progress');
/* The header now mirrors the live store, so #navlinks holds site links
   ("/", "/pages/...") rather than in-page anchors. Only "#..." hrefs are
   valid selectors — passing "/" to querySelector throws a SyntaxError and
   would take the rest of this file down with it. Filter first.
   The active-link highlight simply no-ops while no anchor links are present;
   the progress bar is independent of the nav and keeps working. */
const links = [...document.querySelectorAll('#navlinks a')].filter(a => a.getAttribute('href').startsWith('#'));
const targets = links.map(a => document.querySelector(a.getAttribute('href'))).filter(Boolean);
let ticking = false;
function onScroll() {
  const max = document.documentElement.scrollHeight - innerHeight;
  bar.style.width = (max > 0 ? (scrollY / max) * 100 : 0) + '%';
  let active = -1;
  targets.forEach((t, i) => { if (t.getBoundingClientRect().top <= 150) active = i; });
  links.forEach((a, i) => a.classList.toggle('is-active', i === active));
  sweepVisible();
  ticking = false;
}
addEventListener('scroll', () => {
  if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
}, { passive: true });
onScroll();

/* requestAnimationFrame does not run in a hidden document, so a scroll that happens
   while the tab is backgrounded leaves `ticking` latched and the progress bar and
   active nav link stale. Clear the latch and recompute on the way back in.
   Registered here, after `ticking` and `onScroll` exist. */
addEventListener('visibilitychange', () => {
  if (document.hidden) return;
  ticking = false;
  sweepVisible();
  onScroll();
});

/* ---------- mobile menu drawer ----------
   Below 1080px the desktop nav is hidden, so this is the only route to the
   store's pages. Closing is deliberately over-served — scrim, close button,
   Esc, following a link, and crossing back to desktop width — because a
   drawer you cannot dismiss traps the page. */
const drawer = document.getElementById('drawer');
const burger = document.getElementById('burger');
if (drawer && burger) {
  const desktop = matchMedia('(min-width: 1081px)');

  function openDrawer() {
    drawer.classList.add('open');
    burger.setAttribute('aria-expanded', 'true');
    burger.setAttribute('aria-label', 'Close menu');
    /* The lock itself is CSS, gated by the drawer's own breakpoint — see
       styles.css. All this does is set the flag and hand over the scrollbar
       width so the page does not jump as the scrollbar goes. */
    const gap = innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--sbw', gap > 0 ? gap + 'px' : '0px');
    document.documentElement.classList.add('drawer-open');
    drawer.querySelector('.drawer__links a').focus();
  }

  function closeDrawer({ restoreFocus = true } = {}) {
    if (!drawer.classList.contains('open')) return;
    drawer.classList.remove('open');
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label', 'Open menu');
    document.documentElement.classList.remove('drawer-open');
    /* Focus goes back to the button that opened it, not to whatever happened
       to be focused beforehand — Safari does not focus a button on click, so
       remembering the previous element strands focus on <body> there. */
    if (restoreFocus) burger.focus();
  }

  burger.addEventListener('click', () => {
    drawer.classList.contains('open') ? closeDrawer() : openDrawer();
  });
  drawer.addEventListener('click', (e) => {
    if (e.target.closest('[data-drawer-close]')) closeDrawer();
    /* a link inside the drawer navigates; leave focus alone on the way out */
    else if (e.target.closest('a')) closeDrawer({ restoreFocus: false });
  });
  addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });
  /* resizing up to desktop hides the drawer in CSS; without this the body
     would stay scroll-locked with nothing on screen explaining why */
  desktop.addEventListener('change', (e) => { if (e.matches) closeDrawer({ restoreFocus: false }); });
}

/* ---------- sticky buy bar ---------- */
const buybar = document.getElementById('buybar');
const hero = document.querySelector('.hero');
if (buybar && hero) {
  new IntersectionObserver(([e]) => buybar.classList.toggle('show', !e.isIntersecting), { threshold: 0 })
    .observe(hero);
}
})();

/* #specs: Build & hardware opens too at 981px+, so the tall photo leaves no
   hole under one open drawer (combined page, user call 2026-09-18). */
if (window.matchMedia('(min-width: 981px)').matches) {
  document.querySelectorAll('details[data-open-wide]').forEach((d) => { d.open = true; });
}
